var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-integral-goods-detail',{staticClass:"pt-integral-goods-detail__withData",attrs:{"goodsDetail":_vm.goodsDetail,"mallGoods":_vm.mallGoods}})}
var staticRenderFns = []

export { render, staticRenderFns }